/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-let */
import { Button, Input } from '@nike/frame-component-library';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import './Time.css';

const HOURS = 12;
const MINUTES = 59;

const getFormattedHours = (date) => (date.format('h') === '0' ? '12' : date.format('h'));

class Time extends React.Component {
  constructor(props) {
    super(props);
    this.updateHours = this.updateHours.bind(this);
    this.validateAndSetHours = this.validateAndSetHours.bind(this);
    this.updateMinutes = this.updateMinutes.bind(this);
    this.validateAndSetMinutes = this.validateAndSetMinutes.bind(this);

    const initialDate = props.date || moment().startOf('day');

    this.state = {
      hoursError: false,
      inputHours: getFormattedHours(initialDate),
      inputMinutes: initialDate.format('mm'),
      meridiem: initialDate.format('A'),
      minutesError: false,
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { date } = this.props;
    if (nextProps.date && !nextProps.date.isSame(date)) {
      this.setState({
        inputHours: getFormattedHours(nextProps.date),
        inputMinutes: nextProps.date.format('mm'),
        meridiem: nextProps.date.format('A'),
      });
    }
  }

  updateHours(e) {
    const hours = e.target.value;
    if (hours >= 1 && hours <= HOURS && hours.length !== 0) {
      this.setState({ hoursError: false, inputHours: hours });
    } else {
      this.setState({ hoursError: true, inputHours: hours });
    }
  }

  validateAndSetHours() {
    const { handleSetHours } = this.props;
    const { inputHours, hoursError, meridiem } = this.state;

    if (!hoursError) {
      let correctedHours = parseInt(inputHours, 10);
      // Adjust new hour to PM if meridiem is set to PM
      if (meridiem === 'PM' && correctedHours !== HOURS) {
        correctedHours += HOURS;
      }
      // Convert 12 AM to 0 hours
      if (correctedHours === HOURS && meridiem === 'AM') {
        correctedHours = 0;
      }
      handleSetHours(correctedHours);
    }

    if (parseInt(inputHours, 10) === 0) {
      this.setState({ inputHours: HOURS });
    }
  }

  updateMinutes(e) {
    const minutes = e.target.value;
    if (minutes >= 0 && minutes <= MINUTES) {
      this.setState({ inputMinutes: minutes, minutesError: false });
    } else {
      this.setState({ inputMinutes: minutes, minutesError: true });
    }
  }

  validateAndSetMinutes() {
    const { handleSetMinutes } = this.props;
    const { inputMinutes, minutesError } = this.state;

    if (!minutesError) {
      handleSetMinutes(inputMinutes);
    }
  }

  render() {
    const {
      date, handleToggleMeridiem, isTimeInvalid, label,
    } = this.props;
    const {
      inputHours, inputMinutes, meridiem, hoursError, minutesError,
    } = this.state;
    return (
      <article className="va-sm-b">
        <Input
          errorMessage={hoursError || isTimeInvalid ? ' ' : ''}
          isDisabled={!date}
          label={label}
          style={{ width: '48px' }}
          value={inputHours}
          onBlur={this.validateAndSetHours}
          onChange={this.updateHours}
        />
        <p className="date-colon">&nbsp;:&nbsp;</p>
        <Input
          errorMessage={minutesError || isTimeInvalid ? ' ' : ''}
          isDisabled={!date}
          style={{ width: '48px' }}
          value={inputMinutes}
          onBlur={this.validateAndSetMinutes}
          onChange={this.updateMinutes}
        />
        <Button
          className={`ncss-btn-${meridiem === 'AM' ? 'secondary' : 'primary'}-dark border va-sm-b m2-sm`}
          isDisabled={!date}
          onClick={handleToggleMeridiem}
        >
          {meridiem}
        </Button>
      </article>
    );
  }
}

Time.propTypes = {
  date: PropTypes.instanceOf(moment),
  handleSetHours: PropTypes.func.isRequired,
  handleSetMinutes: PropTypes.func.isRequired,
  handleToggleMeridiem: PropTypes.func.isRequired,
  isTimeInvalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

Time.defaultProps = {
  date: undefined,
  isTimeInvalid: false,
};

export default Time;
